import { render, staticRenderFns } from "./UpdateRuleSelector.vue?vue&type=template&id=b32df94a"
import script from "./UpdateRuleSelector.vue?vue&type=script&lang=js"
export * from "./UpdateRuleSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports